import { render, staticRenderFns } from "./auto-rule.vue?vue&type=template&id=1914fefe&scoped=true&"
import script from "./auto-rule.vue?vue&type=script&lang=js&"
export * from "./auto-rule.vue?vue&type=script&lang=js&"
import style0 from "./auto-rule.vue?vue&type=style&index=0&id=1914fefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1914fefe",
  null
  
)

export default component.exports